import { FieldHeaderComponent, TextFieldComponent } from '@vivli/shared/components';
import { CSSProperties, useState } from 'react';
import { useInputValidation } from '@vivli/shared/infrastructure/hook';
import { ButtonView } from '@vivli/shared/views';
import { PermissionsEnum } from '@vivli/shared/infrastructure/enum';
import { IOrganizationInvitation } from '@vivli/features/organizations/infrastructure/interface';
import { useActiveUserContext, useModalApiContext } from '@vivli/core/infrastructure/context';

const containerStyle: CSSProperties = {
    minHeight: 112,
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flex: '1 0 0'
};
const emailRowStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
};
const firstRowStyle: CSSProperties = {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row'
};

export const AddMemberComponent = ({ organization, isSaving, addOrgMember }) => {
    const { hasPermission } = useActiveUserContext();
    const isVivliAdmin = hasPermission(PermissionsEnum.CreateOrg);
    const inputValidation = useInputValidation();
    const emailErrorText = 'The email is in an invalid format.';
    const [isEmailError, setIsEmailError] = useState(false);
    const [newEmail, setNewEmail] = useState<string>('');
    const { dismiss } = useModalApiContext();

    const handleMemberEmailChange = (email) => {
        email = email.trim();
        const isValid = inputValidation.validateEmail(email);
        setIsEmailError(!isValid);
        setNewEmail(email);
    };

    const handleAddMember = () => {
        //TODO PERMFE - invites-no changes+
        //or we can use the same, just assign rights instead
        const orgInvite: IOrganizationInvitation = {
            email: newEmail,
            orgMembership: {
                orgId: organization.id,
                orgName: organization.name,
                isOrgAdmin: false,
                isIRPApprover: false,
                isDataProvider: false,
                isAnnotator: false,
                isQaReviewer: false,
                isHead: false
            }
        };
        //invite is actually adding, old name
        addOrgMember(orgInvite);
        setNewEmail('');
    };

    //TODO PERMFE - below redo with permissions+
    return (
        <div>
            <FieldHeaderComponent title={'ADD MEMBER'} />
            <div style={containerStyle}>
                <div style={emailRowStyle}>
                    <TextFieldComponent
                        label={'Email'}
                        value={newEmail}
                        readonly={!isVivliAdmin}
                        onChange={(e) => handleMemberEmailChange(e.target.value)}
                        style={{ width: '20em' }}
                        error={isEmailError ? emailErrorText : ''}
                    />
                    <div style={firstRowStyle}>
                        <ButtonView
                            onClick={handleAddMember}
                            disabled={!isVivliAdmin || isSaving || !newEmail || !organization.id || isEmailError}
                            isLoading={isSaving}
                            style={{ marginTop: 15, marginLeft: 0 }}
                        >
                            Add Member
                        </ButtonView>
                        <ButtonView
                            onClick={() => {
                                dismiss();
                            }}
                            style={{ marginTop: 15, marginLeft: 85 }}
                        >
                            Cancel
                        </ButtonView>
                    </div>
                </div>
            </div>
        </div>
    );
};
